import "../../Cash";
import $, { Cash } from "cash-dom";

interface ICarsForSale extends QueryString {
  currentURL: string;
  page: number;
  pageType: string;

  filter: () => void;
  getDynamicFilters: () => void;
}

class QueryString {
  queryString: URLSearchParams;

  constructor() {
    this.queryString = new URLSearchParams(window.location.search);
  }

  public setFilter(key: string, value: string) {
    return this.updateCurrentURL("set", key, value);
  }

  public appendFilter(key: string, value: string) {
    return this.updateCurrentURL("append", key, value);
  }

  public deleteFilter(key: string) {
    return this.updateCurrentURL("delete", key, null);
  }

  private updateCurrentURL(method: string, key: string, value?: string) {
    switch (method) {
      case "set":
        this.queryString.set(key, value);
        break;
      case "append":
        this.queryString.append(key, value);
        break;
      case "delete":
        this.queryString.delete(key);
        break;
    }
    const newRelativePathQuery =
      window.location.pathname + "?" + this.queryString.toString();
    history.pushState(null, "", newRelativePathQuery);
    return this.queryString.toString();
  }
}

export class CarsForSaleController extends QueryString implements ICarsForSale {
  currentURL: string;
  page: number;
  pageType: string;

  constructor() {
    super();
    this.currentURL = `${location.protocol}//${location.host}${location.pathname}`;
  }

  public redirectTo(pageType, params) {
    let url = new URL(this.currentURL);
    if (pageType == "make") {
      url.pathname = `/cars-for-sale/${params[0]}`;
    } else if (pageType == "model") {
      url = new URL(this.currentURL);
      url.pathname += `/${params[0]}`;
    } else if (params != null) {
      let filters = new URLSearchParams(window.location.search);
      filters.delete("page");
      return window.location.replace(
        this.currentURL + `?${filters.toString()}`
      );
    }
    window.location.replace(url);
  }

  protected setLoadingCards(list: Cash) {
    list.empty();
    for (let index = 0; index < 6; index++) {
      list.append(this.loadingCardComponent());
    }
  }

  protected loadingCardComponent() {
    return `
      <div class="column is-4-desktop is-6-tablet is-12-mobile">
      <div id="card-data" class="card card--car p-0">
        <div class="columns is-mobile is-multiline">
          <div class="column is-12 pt-0">
            <div class="skeleton skeleton-rect" style="
                        --rect-h: 190px;
                        --l-h: 40px;
                        --lines: 1;
                    "></div>
            <div class="skeleton skeleton-line" style="--l-h: 40px;"></div>
            <div class="skeleton skeleton-line" style="
                        --c-bg: #F8F7FC;
                        --lines: 5;
                    "></div>
            <div class="skeleton skeleton-line my-3" style="--l-h: 40px;"></div>
          </div>
        </div>
      </div>
    </div>
    `;
  }

  public removeErrorAlert() {
    if ($("#notification-alert").length > 0) {
      $("#notification-alert").remove();
    }
  }

  public filter(): void {
    throw new Error("Method `filter()`not implemented.");
  }

  public getDynamicFilters() {
    throw new Error("Method `getDynamicFilters()`not implemented.");
  }

  public initializeFilters() {
    this.getDynamicFilters();
    this.queryString.forEach((value: string, key: string) => {
      if (key.startsWith("year")) {
        $(`select[name="${key}"]`).val(value).trigger("change");
      } else if ($(`input[name="${key}"]`).attr("type") == "checkbox") {
        $(`input[name="${key}"][value="${value}"]`).prop("checked", true);
      } else {
        $(`input[name="${key}"]`).val(value);
      }
    });
  }

  public async initSliders() {
    throw new Error("Method `initSliders()`not implemented.");
  }

}
